import AboutObjective from '@assets/images/aboutObjective.webp';
import Image from 'next/image';
import AboutUs from './components/AboutUs';
import Objective from './components/Objective';
import OurVision from './components/OurVision';
import Team from './components/Team';
import styles from './styles.module.scss';

const About = () => (
  <main className={styles.container}>
    <AboutUs />
    <Objective />
    <div className={styles.imageContainer}>
      <Image
        fill
        src={AboutObjective}
        className={styles.image}
        alt="Businesswoman showing colleagues note on whiteboard during meeting"
      />
    </div>
    <OurVision />
    <Team />
  </main>
);

export default About;
